import React, { useState, useEffect } from "react";
import { RxCross1 } from "react-icons/rx";
import { FiDownload, FiCalendar } from "react-icons/fi";
import { CSVLink } from "react-csv";
import moment from "moment";
import { useSelector } from "react-redux";

const ResponsesNewModal = (props) => {
  const { loginData } = useSelector((store) => store.Athentication);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [loadData, setLoadData] = useState([]);

  useEffect(() => {
    let finalexport = [];
    const sourceList = props.response || [];

    for (let index = 0; index < sourceList.length; index++) {
      let element = sourceList[index];

      let createdAt = element.createdAt ? new Date(element.createdAt) : null;
      let receivedDate = createdAt ? createdAt.toLocaleDateString() : "N/A";
      let receivedTime = createdAt ? createdAt.toLocaleTimeString() : "N/A";

      let userType =
        element.userOwnerShip === "User" ? "Individual" : element.userOwnerShip;

      let interestedIn = "";
      if (element.noofBedrooms) {
        interestedIn += `${element.noofBedrooms} BHK | `;
      }
      interestedIn += `${element.subcategory || "Property"} for ${
        element.category || ""
      } in ${element.propertyName || ""} ${element.locality || ""}`;

      let productCode = element.propertyId ? element.propertyId : "";

      let formdata = {
        Sno: index + 1,
        Name: element.userName || "N/A",
        Type: userType || "Buyer",
        ContactNo: element.userMobile || "N/A",
        EmailId: element.userEmail || "N/A",
        ReceivedDate: receivedDate,
        Time: receivedTime,
        InterestedIn: interestedIn,
        PropertyId: productCode,
        City: element.city || "",
        Bhk: element.noofBedrooms || "",
        Price: element.price || "",
      };

      finalexport.push(formdata);
    }

    setLoadData(finalexport);
  }, [props.response]);

  return (
    <div style={{ background: "#ffffff", borderRadius: "16px", overflow: "hidden" }}>
      {/* Modal Header */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "16px 20px",
          borderBottom: "1px solid #e2e8f0",
          background: "#fff7ed",
        }}
      >
        <h5
          style={{
            margin: 0,
            fontSize: "16px",
            fontWeight: "800",
            color: "#0f172a",
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <FiDownload color="#ea580c" />
          <span>Export Inquiries & Leads</span>
        </h5>
        <button
          type="button"
          onClick={() => props.toggle()}
          style={{
            background: "transparent",
            border: "none",
            cursor: "pointer",
            padding: "4px",
            color: "#64748b",
            display: "flex",
            alignItems: "center",
          }}
        >
          <RxCross1 size={18} />
        </button>
      </div>

      {/* Modal Body */}
      <div style={{ padding: "20px" }}>
        <p style={{ fontSize: "13px", color: "#64748b", margin: "0 0 16px 0" }}>
          Export all buyer responses and lead contacts directly to a CSV spreadsheet.
        </p>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: "12px", marginBottom: "20px" }}>
          <div>
            <label style={{ fontSize: "12px", fontWeight: "700", color: "#475569", marginBottom: "4px", display: "block" }}>
              Start Date
            </label>
            <input
              type="date"
              className="form-control"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
              style={{ fontSize: "13px", borderRadius: "8px" }}
            />
          </div>
          <div>
            <label style={{ fontSize: "12px", fontWeight: "700", color: "#475569", marginBottom: "4px", display: "block" }}>
              End Date
            </label>
            <input
              type="date"
              className="form-control"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
              style={{ fontSize: "13px", borderRadius: "8px" }}
            />
          </div>
        </div>

        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: "10px" }}>
          <CSVLink
            data={loadData}
            filename={`mgh-responses-${moment().format("YYYY-MM-DD")}.csv`}
            style={{ textDecoration: "none" }}
          >
            <button
              type="button"
              className="mgh-lead-btn-download"
              style={{ padding: "10px 20px" }}
            >
              <FiDownload size={15} />
              <span>Download CSV File</span>
            </button>
          </CSVLink>

          <span style={{ fontSize: "12px", color: "#64748b" }}>
            Total {loadData.length} leads ready for export
          </span>
        </div>

        <p style={{ fontSize: "11.5px", color: "#94a3b8", marginTop: "16px", marginBottom: 0 }}>
          * The export file includes verified buyer names, phone numbers, emails, inquiry dates, and referenced properties.
        </p>
      </div>
    </div>
  );
};

export default ResponsesNewModal;
